// extracted by mini-css-extract-plugin
export default {"title":"styles_title__YmULm","hideSubtitle":"styles_hideSubtitle__Q9sIR","subtitles":"styles_subtitles__t35bJ"};